import { Card } from 'ui/components/primitives';

import { Score } from './ScorePoints.styles';

import type { ScoreProps } from './ScorePoints.d';

const ScorePoints = ({
  descriptionNotification,
  hasRequiredPoints,
  orderUsedPoints,
  remainingPoints,
  titleNotification,
}: ScoreProps) => (
  <Score.Component data-testid="score-campaign">
    {!hasRequiredPoints && (
      <Score.Alert>
        <Score.Title>{titleNotification}</Score.Title>
        <Score.Description>{descriptionNotification}</Score.Description>
      </Score.Alert>
    )}

    <Card radius="rounded">
      <Score.Content data-spacing-top="none">
        <Score.Info>Pontos disponíveis </Score.Info>

        <Score.TotalValue>{remainingPoints} pontos</Score.TotalValue>
      </Score.Content>

      {hasRequiredPoints && (
        <Score.Content>
          <Score.Info>Pontos sendo utilizados </Score.Info>
          <Score.TotalValue>{orderUsedPoints} pontos</Score.TotalValue>
        </Score.Content>
      )}
    </Card>
  </Score.Component>
);

export default ScorePoints;
